import type { FaireProductEntity } from "../../entity_types/product";

export const p_tx4kgrz3zp: FaireProductEntity = {
  token: "p_tx4kgrz3zp",
  type: "product",
  name: "Spring 2026 Leopard Print Canvas Tote Bag Gifts",
  brandToken: "b_fpqcwkn7v8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/0e473456f990c20302234de16ff8dcf1e825330e55f49506db67774f7a1614e8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f84a8054c7cef89c6d9d9cb6e0b4e87fd7e5f8ec6755b2492b3c50d432fc548c.jpeg",
    "https://cdn.faire.com/fastly/5b8342087ce5e72fd2bf1106d1987bffc17bedc8de76e88685894c0e7576885a.jpeg",
    "https://cdn.faire.com/fastly/7abebbc74f3d649a540f12fdd8990b06e28005ad0c2d0cea2ee9da52ca8eb265.jpeg",
    "https://cdn.faire.com/fastly/906fe7ccb70d5d10e8dfeae2a14e6118b3ea1fed33e1ae9075922744935888aa.jpeg",
    "https://cdn.faire.com/fastly/16947e8f17db3f7063007cd988a091114c0f13cd084ad82534be589d52979fc0.jpeg",
    "https://cdn.faire.com/fastly/2f0d68548c00afc6599c553c3726780cdbdd9a340f9df4f5c106fbac0a20931e.jpeg",
    "https://cdn.faire.com/fastly/f20f7d133917ecb5a62b40d3881542613057cedb8529535d41b412831e5ba331.jpeg",
    "https://cdn.faire.com/fastly/3b883a71314ee1f6509431c517cbef3c72b8333568c67f09402d1e18e8804ad9.jpeg",
    "https://cdn.faire.com/fastly/03bb9840ede5165cb02a3755b97b0a83513bee3984608a94703ec442f8d950c4.jpeg",
    "https://cdn.faire.com/fastly/68aae356499201cff301bcbcff6a080e858f15e9152a5a5790f66bc2b500de8f.jpeg",
    "https://cdn.faire.com/fastly/58f02a92bf6901c027e6c26dbe2e64479a645d87747252156b624ea65caae3a4.jpeg",
    "https://cdn.faire.com/fastly/933933ed3569efeb8b89b846dcfacb2a4bed0e1952b318c67f5cb033ab26a916.jpeg",
    "https://cdn.faire.com/fastly/1b8d9422b5e26c4870e051f0d68bd0afa73ab244274cd6c920133ce194ea6690.jpeg",
    "https://cdn.faire.com/fastly/07ad84db38cec9bbd50eb82708868e9bf72bce62255b4fa0e5ed28d8a0f147c7.jpeg",
    "https://cdn.faire.com/fastly/fec1fa2b6c5c6ef473bb946ccaaecc2ce24cee7475c2bd264e9746d3131f21f7.jpeg",
    "https://cdn.faire.com/fastly/6a40892016f07ce12647c2baa0394efc516677061dc1d3945d1f80a260fe70d9.jpeg",
    "https://cdn.faire.com/fastly/c2827b60045199c82b1c9dcbaf2bd4e4112a7c4a0b43d4bdf86c8cebfa986790.jpeg",
  ],
  priceDollars: 13.93,
  description:
    "🎀Material: 100%Polyester\n😍Why You’ll Love It?\n\nClassic leopard prints provide a trendy and fierce look for daily errands\nDurable canvas material ensures a sturdy and reliable frame for the bag\nSpacious tote design offers a practical and organized aesthetic for carrying essentials\nVersatile printed construction creates a bold and stylish silhouette for any outfit\nbag size: 16.9 × 5.9 × 11 inches\n\n💌Note: Our products currently come with size and care labels only. If you need branded labels, please contact us for custom options!",
  tags: [],
  msrpDollars: 27.85,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:36.155Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
